<template>
	<div class="cjt-container">
		<div class="cjt-head">
			<div class="head-content">
				<router-link to="/index" class="logo">
					<img src="@/assets/logo.png" alt="楚建通" />
					<div class="logo-text">
						<span class="divider"></span>

						<span>创新服务 共建共赢</span>
					</div>
				</router-link>

				<div class="contact">
					<router-link to="/index" class="website">楚建通官网</router-link>
					<div class="contact-tel">
						<img src="@/assets/login/tel.png" alt="电话" />
						<span>400-992-5998</span>
					</div>
				</div>
			</div>
		</div>

		<div class="cjt-main">
			<div class="lgoin-content">
				<div class="left-section">
					<div class="platform-image">
						<img src="@/assets/login/platform.png" alt="平台展示" class="main-image" />
						<div class="feature-tags">
							<div class="tag-item tag-efficiency floating">
								<!-- <span>提高办理效率</span> -->
							</div>
							<div class="tag-item tag-income floating">
								<!-- <span>清晰收入分</span> -->
							</div>
							<div class="tag-item tag-account floating">
								<!-- <span>便捷智能对账</span> -->
							</div>
							<div class="tag-item tag-service floating">
								<!-- <span>一站式服务</span> -->
							</div>
						</div>
					</div>
				</div>

				<div class="right-section">
					<div class="form-container">
						<div v-if="activeTab === 'forgetPassword'" class="form-tabs">
							<div class="tab-item" :class="{ active: activeTab === 'forgetPassword' }" @click="activeTab = 'forgetPassword'">
								忘记密码
							</div>
						</div>
						<div v-else class="form-tabs">
							<div class="tab-item" :class="{ active: activeTab === 'login' }" @click="activeTab = 'login'">登录</div>
							<div class="tab-item" :class="{ active: activeTab === 'register' }" @click="activeTab = 'register'">注册</div>
						</div>

						<!-- 登录表单 -->
						<div v-show="activeTab === 'login'" class="form-content">
							<el-form ref="loginForm" :model="loginForm" :rules="rules">
								<el-form-item prop="phone" class="form-item">
									<el-input v-model="loginForm.phone" type="text" placeholder="请输入手机号码" @keyup.enter.native="handleLogin">
										<span slot="prefix" class="svg-container"><svg-icon icon-class="mobile" /></span>
									</el-input>
								</el-form-item>

								<el-form-item prop="password" class="form-item">
									<el-input
										v-model="loginForm.password"
										placeholder="请输入密码"
										@keyup.enter.native="handleLogin"
										:type="passwordType"
									>
										<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
									</el-input>
									<span class="show-pwd svg-container" @click="showPwd">
										<svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
									</span>
								</el-form-item>

								<el-form-item prop="captchaCode" class="form-item">
									<div class="code-container">
										<el-input
											v-model="loginForm.captchaCode"
											auto-complete="off"
											placeholder="请输入验证码"
											style="width: 55%"
											@keyup.enter.native="handleLogin"
										>
											<span slot="prefix" class="svg-container"><svg-icon icon-class="validCode" /></span>
										</el-input>
										<div class="login-code">
											<el-image :src="codeUrl" class="login-code-img" fit="fill" @click="getCode">
												<div slot="error" class="image-slot">
													<i class="el-icon-picture-outline"></i>
												</div>
											</el-image>
										</div>
									</div>
								</el-form-item>

								<div class="form-options">
									<a href="javascript:;" @click="activeTab = 'forgetPassword'">忘记密码？</a>
								</div>
								<el-button class="submit-btn" type="button" :loading="loading" @click.native.prevent="handleLogin">
									登录
								</el-button>

								<div class="other-login-way">
									<div class="other-login-divider">
										<span>其他登录方式</span>
									</div>
									<el-button
										class="unified-auth-btn"
										type="button"
										:loading="unifiedAuthLoading"
										@click.native.prevent="handleUnifiedAuthLogin"
									>
										<i class="el-icon-user-solid"></i>
										统一身份认证登录
									</el-button>
								</div>
							</el-form>
						</div>

						<!-- 注册表单 -->
						<div v-show="activeTab === 'register'" class="form-content">
							<el-form ref="registerForm" :model="registerForm" :rules="rules">
								<el-form-item prop="realName" class="form-item">
									<el-input v-model="registerForm.realName" type="text" placeholder="请输入用户名">
										<span slot="prefix" class="svg-container"><svg-icon icon-class="user" /></span>
									</el-input>
								</el-form-item>
								<el-form-item prop="phone" class="form-item">
									<el-input v-model="registerForm.phone" type="text" placeholder="请输入手机号码">
										<span slot="prefix" class="svg-container"><svg-icon icon-class="mobile" /></span>
									</el-input>
								</el-form-item>
								<el-form-item prop="captcha" class="form-item">
									<el-input v-model="registerForm.captcha" type="text" placeholder="请输入收到的短信验证码">
										<span slot="prefix" class="svg-container"><svg-icon icon-class="captcha" /></span>
										<template slot="append">
											<el-button size="mini" :disabled="interval !== null" @click="handleSendMsg">
												{{ interval ? timeout + '秒后重试' : '获取验证码' }}
											</el-button>
										</template>
									</el-input>
									<!-- <button class="code-btn">获取验证码</button> -->
								</el-form-item>
								<el-form-item prop="password" class="form-item">
									<el-input v-model="registerForm.password" :type="passwordType2" placeholder="设置登录密码6-18位数字字母">
										<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
									</el-input>
									<span class="show-pwd svg-container" @click="showPwd2">
										<svg-icon :icon-class="passwordType2 === 'password' ? 'eye' : 'eye-open'" />
									</span>
								</el-form-item>
								<div class="agreement">
									<input v-model="agreement" id="agreement" type="checkbox" />
									<label for="agreement">
										我已阅读并同意
										<a href="javascript:;" @click="dialogVisible = true">《楚建通用户注册协议》</a>
									</label>
								</div>
								<button class="submit-btn" type="button" :loading="loading" @click="handleRegister">注册</button>
							</el-form>
						</div>

						<!-- 忘记密码表单 -->
						<div v-show="activeTab === 'forgetPassword'" class="form-content">
							<el-form ref="forgetPasswordForm" :model="forgetPasswordForm" :rules="rules">
								<el-form-item prop="userName" class="form-item">
									<el-input v-model="forgetPasswordForm.userName" type="text" placeholder="请输入手机号码">
										<span slot="prefix" class="svg-container"><svg-icon icon-class="mobile" /></span>
									</el-input>
								</el-form-item>
								<el-form-item prop="messageAuthCode" class="form-item">
									<el-input v-model="forgetPasswordForm.messageAuthCode" type="text" placeholder="请输入收到的短信验证码">
										<span slot="prefix" class="svg-container"><svg-icon icon-class="captcha" /></span>
										<template slot="append">
											<el-button size="mini" :disabled="interval !== null" @click="handleResetPasswordSendMsg">
												{{ interval ? timeout + '秒后重试' : '获取验证码' }}
											</el-button>
										</template>
									</el-input>
									<!-- <button class="code-btn">获取验证码</button> -->
								</el-form-item>
								<el-form-item prop="newPassword" class="form-item">
									<el-input
										v-model="forgetPasswordForm.newPassword"
										:type="passwordType3"
										placeholder="请输入新密码6-18位数字字母"
									>
										<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
									</el-input>
									<span class="show-pwd svg-container" @click="showPwd3">
										<svg-icon :icon-class="passwordType3 === 'password' ? 'eye' : 'eye-open'" />
									</span>
								</el-form-item>

								<div class="form-options">
									<a href="javascript:;" @click="activeTab = 'login'">返回登录</a>
								</div>
								<el-button class="submit-btn" type="button" :loading="loading" @click.native.prevent="handleResetPassword">
									提交
								</el-button>
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 底部icp备案及版权 -->
		<copyright></copyright>

		<el-dialog title="" :visible.sync="dialogVisible" :show-close="false" width="1500px" top="10vh" class="agreementDialog">
			<reg-agreement></reg-agreement>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleAgreeAndContinue">同意并继续</el-button>
				<el-button @click="handleCancel">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Copyright from '@/components/PageFooter/copyright'
	import RegAgreement from './regAgreement.vue'
	import { validateMobile, validatePassword } from '@/utils/jr-validate'
	import { registerUserInfo, sendMsgAuthCode, forgetPassword, getCaptcha } from '@/api/user'
	import unifiedAuthMixin from '@/mixins/unifiedAuth'

	//  登录页面
	export default {
		name: 'Login',
		components: {
			RegAgreement,
			Copyright
		},
		mixins: [unifiedAuthMixin],
		props: {},
		data() {
			return {
				activeTab: 'login',
				interval: null,
				timeout: 60,
				codeUrl: '',
				loginForm: {
					realName: '',
					password: '',
					phone: '',
					captchaId: '',
					captchaCode: ''
					// captcha: '1234'
				},
				registerForm: {
					realName: '',
					password: '',
					phone: '',
					captcha: ''
				},
				forgetPasswordForm: {
					userName: '',
					messageAuthCode: '',
					newPassword: ''
				},
				rules: {
					realName: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
					captcha: [{ required: true, trigger: 'blur', message: '请输入短信验证码' }],
					phone: [
						{ required: true, trigger: 'blur', message: '请输入手机号' },
						{ validator: validateMobile, trigger: 'blur' }
					],
					password: [
						{ required: true, trigger: 'blur', message: '请输入密码' },
						{ validator: validatePassword, trigger: 'blur' }
					],
					captchaCode: [{ required: true, trigger: 'blur', message: '请输入图形验证码' }],
					userName: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
					messageAuthCode: [{ required: true, trigger: 'blur', message: '请输入短信验证码' }],
					newPassword: [
						{ required: true, trigger: 'blur', message: '请输入新密码' },
						{ validator: validatePassword, trigger: 'blur' }
					]
				},
				loading: false,
				agreement: false,

				// 路由跳转
				redirect: undefined,
				passwordType: 'password',
				passwordType2: 'password',
				passwordType3: 'password',

				dialogVisible: false
			}
		},
		computed: {},
		watch: {
			$route: {
				handler: function(route) {
					this.redirect = route.query && route.query.redirect
				},
				immediate: true
			}
		},
		created() {},
		mounted() {
			this.getCode()
		},
		methods: {
			handleUnifiedAuthLogin() {
				this.redirectToUnifiedAuthLogin()
			},
			showPwd() {
				if (this.passwordType === 'password') {
					this.passwordType = ''
				} else {
					this.passwordType = 'password'
				}
			},
			showPwd2() {
				if (this.passwordType2 === 'password') {
					this.passwordType2 = ''
				} else {
					this.passwordType2 = 'password'
				}
			},
			showPwd3() {
				if (this.passwordType3 === 'password') {
					this.passwordType3 = ''
				} else {
					this.passwordType3 = 'password'
				}
			},
			getCode() {
				// 转成字符串形式
				this.loginForm.captchaId = new Date().getTime() + ''
				this.codeUrl = getCaptcha(this.loginForm.captchaId)
			},
			// 执行登录
			handleLogin() {
				this.$refs.loginForm.validate(valid => {
					if (valid) {
						this.loading = true
						const data = {
							...this.loginForm
						}

						this.$store
							.dispatch('user/login', data)
							.then(() => {
								this.$router.push({ path: this.redirect || '/index' })
								this.loading = false
							})
							.catch(() => {
								this.getCode()
								this.loading = false
							})
					}
				})
			},

			// 用户注册
			handleRegister() {
				if (!this.agreement) {
					this.$message.error('请先同意《楚建通用户注册协议》')
					return
				}
				this.$refs.registerForm.validate(valid => {
					if (valid) {
						this.loading = true
						console.log('this.registerForm:', this.registerForm)
						const data = {
							...this.registerForm
						}
						registerUserInfo(data)
							.then(response => {
								this.$message.success('注册成功')
								this.loading = false

								// 注册成功，切换至登录页签，并将注册表单清空
								this.activeTab = 'login'
								this.$refs.registerForm.resetFields()
							})
							.catch(() => {
								this.loading = false
							})
					}
				})
			},

			// 用户重置密码
			handleResetPassword() {
				this.$refs.forgetPasswordForm.validate(valid => {
					if (valid) {
						this.loading = true
						console.log('this.registerForm:', this.registerForm)
						const data = {
							...this.forgetPasswordForm
						}
						forgetPassword(data)
							.then(response => {
								this.$message.success('密码重置成功')
								this.loading = false

								// 重置密码成功，切换至登录页签，并将注册表单清空
								this.activeTab = 'login'
								this.$refs.registerForm.resetFields()
							})
							.catch(() => {
								this.loading = false
							})
					}
				})
			},

			// 注册时发送短信验证码
			handleSendMsg() {
				if (!this.registerForm.phone) {
					this.$message.error('请填写手机号')
					return
				}
				this.timeout = 60
				this.interval = setInterval(() => {
					this.timeout--
					if (this.timeout === 0) {
						clearInterval(this.interval)
						this.interval = null
					}
				}, 1000)

				const pramas = {
					phoneNumber: this.registerForm.phone
				}
				sendMsgAuthCode(pramas).then(res => {
					this.$message.success('验证码发送成功')
				})
			},
			// 重置密码时发送短信验证码
			handleResetPasswordSendMsg() {
				if (!this.forgetPasswordForm.userName) {
					this.$message.error('请填写手机号')
					return
				}
				this.timeout = 60
				this.interval = setInterval(() => {
					this.timeout--
					if (this.timeout === 0) {
						clearInterval(this.interval)
						this.interval = null
					}
				}, 1000)

				const pramas = {
					phoneNumber: this.forgetPasswordForm.userName
				}
				sendMsgAuthCode(pramas).then(res => {
					this.$message.success('验证码发送成功')
				})
			},

			// 同意并继续
			handleAgreeAndContinue() {
				this.agreement = true
				this.dialogVisible = false
			},
			handleCancel() {
				this.agreement = false
				this.dialogVisible = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './login.scss';
	@import '~@/styles/element-reset.scss';
	.mt0 {
		margin-top: 0px !important;
	}
	.dialog-content {
		height: 450px;
		overflow-y: auto;
		.dialog-title {
			font-size: 16px;
			text-align: center;
		}
		p {
			color: #666;
			font-size: 14px;
			line-height: 22px;
			list-style: none;
			margin-bottom: 6px;
			position: relative;
		}
	}
	.show-pwd {
		position: absolute;
		right: 10px;
		top: 0px;
		font-size: 16px;
		color: #3e8eff;
		cursor: pointer;
		user-select: none;
	}

	.agreementDialog {
		::v-deep {
			.el-dialog__header {
				padding: 0;
			}

			.el-dialog__body {
				padding: 0;
			}
		}
	}
</style>
